import { RxapFormControl } from 'eurogard-forms';

export function uuidValidator(control: RxapFormControl<string>): { [key: string]: boolean } | null {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (control.value && !uuidRegex.test(control.value)) {
    return { invalidUuid: true };
  }
  return null;
}
